document.addEventListener("DOMContentLoaded", () => {
        setTimeout(function () {
          yy_monitor = $(".price.inc-vat.totalprice")[0];
          yy_paypalprice = yy_monitor.getAttribute("data-price");

          paypal
            .Messages({
              amount: yy_paypalprice,
              pageType: "product-details",
              style: {
                layout: "text",
                logo: {
                  type: "inline",
                  position: "top",
                },
                text: {
                  size: "14",
                },
              },
            })
            .render(".pp-message");

          var observer = new MutationObserver(function (mutations) {
            paypalprice = $(".price.inc-vat.totalprice")[0].getAttribute("data-price");
            paypal.Messages({ amount: paypalprice }).render(".pp-message");
          });

          observer.observe(yy_monitor, {
            attributes: true,
            attributeFilter: ["data-price"],
          });
        }, 1500);
      });